import { getAccountList } from '@common/core/network/NodeAPI';
import { getUserStatus } from '@common/core/network/TypeAPI';
export var IUserStatus;
(function (IUserStatus) {
    IUserStatus[IUserStatus["NO_LOGIN"] = 0] = "NO_LOGIN";
    IUserStatus[IUserStatus["NO_ACCOUNT"] = 1] = "NO_ACCOUNT";
    IUserStatus[IUserStatus["NO_ACTIVE"] = 2] = "NO_ACTIVE";
    IUserStatus[IUserStatus["UNKNOWN"] = -1] = "UNKNOWN";
})(IUserStatus || (IUserStatus = {}));
/**
 * 账户管理
 */
export default class AccountManager {
    /**
     * 静态初始化函数
     */
    static init() {
        return (async function () {
            const acctManager = new AccountManager();
            await acctManager.build();
            return acctManager;
        })();
    }
    /**
     * 当前账号
     */
    currentAccount = {
        cardNo: '',
        acctNo: '',
        acctName: '',
        acctAlias: '',
        ccy: '',
        country: '',
        openDate: '',
        usableBalance: '',
        balance: '',
        attribute: '',
        limit: '',
    };
    // 用户状态
    userOpenAccountStatus = {
        uidStr: '',
        status: IUserStatus.UNKNOWN,
        acctNo: '',
        custNo: '',
        gid: '',
        freezeStatus: ''
    };
    /**
     * 用户账号列表，用户可能会存在多个账号
     */
    accountList = [];
    /**
     * 当前账号
     */
    currentAccountNo = '';
    constructor(acctNo = '') {
        this.currentAccountNo = acctNo;
    }
    /**
     * 数据构造
     */
    async build() {
        this.accountList = await getAccountList();
        this.userOpenAccountStatus = await getUserStatus();
        if (this.currentAccountNo) {
            this.currentAccount = this.getAccountByNo(this.currentAccountNo);
        }
        else {
            this.currentAccount = this.accountList[0] || null;
        }
    }
    /**
     * 通过账号号获取账户完整信息
     * @param acctNo 账户号
     */
    getAccountByNo(acctNo) {
        const arr = this.accountList.filter((item) => item.acctNo == acctNo);
        return arr[0] || null;
    }
    /**
     * 获取当前账号
     */
    getAccountNo() {
        return this.currentAccount ? this.currentAccount.acctNo : '';
    }
    /**
     * 获取用户开户状态
     */
    getUserStatus() {
        return this.userOpenAccountStatus.status;
    }
    /**
     * 检查用户账户状态
     */
    checkValid() {
        const status = this.getUserStatus();
        // 除了异常状态，其他状态认定账户正常
        const bValid = ![IUserStatus.NO_ACCOUNT, IUserStatus.NO_ACTIVE, IUserStatus.NO_LOGIN, IUserStatus.UNKNOWN].includes(status);
        return bValid;
    }
}
